import { configureStore } from "@reduxjs/toolkit";
import webSocketService from "../helper/WebSocketService";
import { apiSlice } from "./apiSlice/apiSlice";
import "./apiSlice/relationshipApiSlice";
import { portalCustomerApiSlice } from "./apiSlice/portalCustomerApiSlice";
import { resourceSyncApiSlice } from "./apiSlice/resourceSyncApiSlice";
import { sseMiddleware } from "./middleware";
import { dataResetMiddleware } from "./dataResetSync";
import { createResourceSyncMiddleware } from "./resourceSync";
import accountReducer from "./slice/accountSlice";
import authReducer from "./slice/authSlice";
import chatReducer from "./slice/chatSlice";
import complianceReducer from "./slice/complianceSlice";
import configReducer from "./slice/configSlice";
import currencyReducer from "./slice/currencySlice";
import customerReducer from "./slice/customerSlice";
import fileReducer from "./slice/fileSlice";
import ingestReducer from "./slice/ingestSlice";
import integrationSlice from "./slice/integrationSlice";
import invoiceReducer from "./slice/invoiceSlice";
import manufacturingOrderReducer from "./slice/manufacturingOrderSlice";
import miscReducer from "./slice/miscSlice";
import newInterfaceReducer from "./slice/newInterfaceSlice";
import notificationReducer from "./slice/notificationSlice";
import orderReducer from "./slice/orderSlice";
import plannerReducer from "./slice/plannerSlice";
import portalAuthReducer from "./slice/portalAuthSlice";
import portalContextReducer from "./slice/portalContextSlice";
import portalReducer from "./slice/portalSlice";
import pricingReducer from "./slice/pricingSlice";
import productionReducer from "./slice/productionSlice";
import productSlice from "./slice/productSlice";
import promoReducer from "./slice/promoSlice";
import purchaseOrderReducer from "./slice/purchaseOrderSlice";
import newPurchaseOrderReducer from "./slice/purchaseOrderSliceV2";
import receiptReducer from "./slice/receiptSlice";
import reportReducer from "./slice/reportSlice";
import salesReducer from "./slice/salesSlice";
import shipmentReducer from "./slice/shipmentSlice";
import supplierReducer from "./slice/supplierSlice";
import taxReducer from "./slice/taxSlice";
import newTransferOrderReducer from "./slice/TransferOrderSliceV2";
import unitOfMeasureReducer from "./slice/unitOfMeasureSlice";
import userReducer from "./slice/userSlice";
import warehouseReducer from "./slice/warehouseSlice";
import newWarehouseReducer from "./slice/warehouseSliceV2";
import webSocketReducer from "./slice/webSocketSlice";

const resourceSyncMiddleware = createResourceSyncMiddleware({
  api: resourceSyncApiSlice,
  socket: webSocketService,
});

// Configure the Redux store.
export const store = configureStore({
  // Enable Redux DevTools in development mode for easier debugging.
  devTools: process.env.NODE_ENV !== "production",

  // Middleware Setup.
  middleware: getDefaultMiddleware =>
    // Start with the default middleware provided by Redux Toolkit.
    getDefaultMiddleware()
      // Add the middleware from the apiSlice for handling async actions and side effects.
      .concat(apiSlice.middleware)
      // Add the middleware from the middlewares for handling server side event side effects.
      .concat(sseMiddleware)
      .concat(resourceSyncMiddleware)
      // data_reset WS envelopes → RTK cache (no GET poll).
      .concat(dataResetMiddleware)
      .concat(portalCustomerApiSlice.middleware),

  // Define the reducers for the store.
  // Each reducer manages its own part of the global state.
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    chat: chatReducer,
    compliance: complianceReducer,
    config: configReducer,
    currency: currencyReducer,
    file: fileReducer,
    ingest: ingestReducer,
    integration: integrationSlice,
    invoice: invoiceReducer,
    misc: miscReducer,
    order: orderReducer,
    planner: plannerReducer,
    product: productSlice,
    purchaseOrder: purchaseOrderReducer,
    receipt: receiptReducer,
    report: reportReducer,
    shipment: shipmentReducer,
    supplier: supplierReducer,
    user: userReducer,
    warehouse: warehouseReducer,
    webSocket: webSocketReducer,
    newInterface: newInterfaceReducer,
    newPurchaseOrder: newPurchaseOrderReducer,
    newTransferOrder: newTransferOrderReducer,
    newWarehouse: newWarehouseReducer,
    account: accountReducer,
    tax: taxReducer,
    notification: notificationReducer,
    customer: customerReducer,
    unitOfMeasure: unitOfMeasureReducer,
    sales: salesReducer,
    pricing: pricingReducer,
    promo: promoReducer,
    portal: portalReducer,
    portalAuth: portalAuthReducer,
    portalContext: portalContextReducer,
    production: productionReducer,
    manufacturingOrder: manufacturingOrderReducer,
    [portalCustomerApiSlice.reducerPath]: portalCustomerApiSlice.reducer,
  },
});
